import { render, staticRenderFns } from "./poa_funciones.vue?vue&type=template&id=6f7536c2&"
import script from "./poa_funciones.vue?vue&type=script&lang=ts&"
export * from "./poa_funciones.vue?vue&type=script&lang=ts&"
import style0 from "./poa_funciones.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports